// Default purchase intent options
export const purchaseIntents = [
    {key: 'WITHIN_A_WEEK', label: 'Within a Week'},
    {key: 'STILL_SHOPPING', label: 'Still Shopping'}
]
